function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}


document.addEventListener('DOMContentLoaded', function () {
  let formattedPathSegment = ''
  let filterApi = `https://phpstack-1204751-4260962.cloudwaysapps.com/api/custom/filters?collection_id=${collectionId}&special_tags=${formattedPathSegment}`;
  let filterValApi = `https://phpstack-1204751-4260962.cloudwaysapps.com/api/Apply/filters/new/base?special_tags=${formattedPathSegment}`;
  const body = document.body;
  const wrapper = document.querySelector('.landing-page-exhibition');
  if (!wrapper) return;
  const Header = wrapper ? wrapper.querySelector('.heading_search_header') : null ;
  const AllIBackTOLIst = document.querySelectorAll('.back-to-list');
  AllIBackTOLIst?.forEach((btn) => {
    btn.addEventListener('click', function() {
      var Parent = this.closest('body');
      var selector = this.getAttribute('data-input');
      var Prevselector = this.getAttribute('data-prev-input');
      var Input = Parent.querySelector(selector);
      var PrevInput = Parent.querySelector(Prevselector);
        // PrevInput?.focus();
        Input?.classList.remove('is_active');
        PrevInput?.classList.add('is_active');
      if(Header){ Header.textContent = PrevInput.getAttribute('data-heading')}
    });
  });
  const elements = {
    mobileModelOpener: wrapper.querySelectorAll('[toggle-parts-model]'),
    mobileModel: wrapper.querySelector('[model-wapper]'),
    brandInputs: wrapper.querySelectorAll('[brands-finder]'),
    modelInputs: wrapper.querySelectorAll('[modles-finder]'),
    yearInputs: wrapper.querySelectorAll('[years-finder]'),
    brandLists: wrapper.querySelectorAll('#brands_list'),
    modelLists: wrapper.querySelectorAll('#modles_list'),
    yearLists: wrapper.querySelectorAll('#years_list'),
    searchBtn: wrapper.querySelector('.partfinder-button'),
    resetBtns: wrapper.querySelectorAll('#reset_btn'),
    header: wrapper.querySelector('.heading_search_header'),
    breadcrumbs: wrapper.querySelector('.breadcrums-search-model'),
    modelSearchBtn: wrapper.querySelector('.search_vhical_btn'),
    modelSearchInput: wrapper.querySelector('.serach_vhical_input')
  };

  const handleEnterKey = (event, btn) => event.key === "Enter" && btn.click();

  elements.modelSearchInput?.addEventListener("keydown", (event) => handleEnterKey(event, elements.modelSearchBtn));
  [elements.brandInputs[0], elements.modelInputs[0], elements.yearInputs[0]].forEach(input => {
    input?.addEventListener("keydown", (event) => handleEnterKey(event, elements.searchBtn));
  });

  let is_open = false;

  const toggleModelOpener = () => {
    elements.mobileModel.classList.toggle('is_active');
    elements.modelInputs[0]?.classList.remove('is_active');
    elements.modelLists[0].innerHTML = '';
    elements.yearInputs[0]?.classList.remove('is_active');
    elements.yearLists[0].innerHTML = '';
    elements.header.textContent = 'Velg bilmerke';
    elements.breadcrumbs.querySelectorAll('.brand, .model, .year').forEach(el => el.innerHTML = '');
  };

  elements.mobileModelOpener.forEach(btn => { 
    btn.addEventListener('click', (event) => {
      // console.log('mobileModelOpener',event.target);
      toggleModelOpener();
      if(event.target.classList.contains('close_icon_model_mobile')){
        
        var mobileSelectionInputs = elements.mobileModel.querySelectorAll('.block_finder_input input[data-heading]');
        console.log('elements.mobileModel inputs',mobileSelectionInputs)
        mobileSelectionInputs?.forEach(mobileSelectionInput => {
          mobileSelectionInput.value = '';
          
          var allOptionsLists = document.querySelectorAll('.list_partfinder');
          if(allOptionsLists){
            allOptionsLists.forEach(allOptionsList => {
              var optionListItems = allOptionsList.querySelectorAll('li');
              optionListItems?.forEach(optionListItem => {
                optionListItem.style.display = '';
              })
            })
          }
          
          
        })
      }
    });
  });
  const setCookie = (name, value, days) => {
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${new Date(Date.now() + days * 864e5).toUTCString()}; path=/`;
  };

  const getCookie = (name) => {
    const cookie = document.cookie.split('; ').find(row => row.startsWith(name + '='));
    return cookie ? decodeURIComponent(cookie.split('=')[1]) : null;
  };

  const appendToCookieArray = (newItem) => {
    let carsArray = getCookie('carsData') ? JSON.parse(getCookie('carsData')) : [];
    carsArray.push(newItem);
    setCookie('carsData', JSON.stringify(carsArray), 7);
  };

  const fetchData = async (url, data = {}) => {
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      if (!response.ok) throw new Error('Network response was not ok.');
      return await response.json();
    } catch (error) {
      console.error('Error fetching data:', error);
      return [];
    }
  };

  const populateList = (listElement, data, valueKey, textKey, isBrand = false, popularBrands = []) => {
    listElement.innerHTML = '';
      const iconCaret = `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-caret" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M6.29289 8.79289C6.68342 8.40237 7.31658 8.40237 7.70711 8.79289L12 13.0858L16.2929 8.79289C16.6834 8.40237 17.3166 8.40237 17.7071 8.79289C18.0976 9.18342 18.0976 9.81658 17.7071 10.2071L12.7071 15.2071C12.3166 15.5976 11.6834 15.5976 11.2929 15.2071L6.29289 10.2071C5.90237 9.81658 5.90237 9.18342 6.29289 8.79289Z" fill="currentColor"/>
          </svg>`
    if (isBrand && popularBrands.length) {
      const fragment = document.createDocumentFragment();
      const createHeading = (text) => {
        const h3 = document.createElement('h3');
        h3.textContent = text;
        return h3;
      };
      const createSection = () => document.createElement('div');
      fragment.appendChild(createHeading('Populær Bilmerker'));
      const popularSection = createSection();
      popularBrands.forEach(item => popularSection.innerHTML += `<li data-value="${item[valueKey]}" data-content="${item[textKey]}">${item[textKey]} ${iconCaret}</li>`);
      fragment.appendChild(popularSection);
      
      fragment.appendChild(createHeading('Alle Bilmerker'));
      const allSection = createSection();
      data.forEach(item => allSection.innerHTML += `<li data-value="${item[valueKey]}" data-content="${item[textKey]}">${item[textKey]} ${iconCaret}</li>`);
      fragment.appendChild(allSection);

      listElement.appendChild(fragment);
    } else{
      let newData = data.models ? data.models : data.years
      
      newData.forEach(item => {
        let value = item[valueKey] ? item[valueKey]: item ;
        let text = item[textKey] ? item[textKey]: item ;
        listElement.innerHTML += `<li data-value="${value}" data-content="${text}">${text} ${iconCaret}</li>`});
    }
  };

  const filterList = (inputElement, listElement) => {
    const filterText = inputElement.value.toLowerCase();
    listElement.querySelectorAll('li').forEach(item => {
      item.style.display = item.textContent.toLowerCase().includes(filterText) ? '' : 'none';
    });
  };

  const handleBrandClick = async (event) => {
        if(event.target.matches('li')){
    const mainWrapper = event.target.closest('[main-wrapper]');
    
    if (!mainWrapper) return;

    const mainListWrapper = event.target.closest('.wrapper_finder_input').nextElementSibling;
    const theArrowIcon = mainListWrapper.querySelector('.back-to-list');

    mainWrapper.querySelector('[modles-finder]').value = ''; // Clear model search input
    mainWrapper.querySelector('#years_list').innerHTML = ''; // Clear year list
    mainWrapper.querySelector('[years-finder]').removeAttribute('data-tag');
    mainWrapper.querySelector('[modles-finder]').removeAttribute('data-tag');
    mainWrapper.querySelector('[years-finder]').value = '';

    // mainListWrapper.querySelector   
    if(theArrowIcon && body.clientWidth < 1025 || body.clientWidth >= 1025){
      // theArrowIcon.style.display = 'flex';
      theArrowIcon.classList.add('is_shown');
      // console.log('mainListWrapper',mainListWrapper,event.target,theArrowIcon);
    }      
    
    
    const selectedBrand = event.target.dataset.value;
    mainWrapper.querySelector('[modles-finder]').removeAttribute('disabled');
    
    const input = mainWrapper.querySelector('[brands-finder]');
    input.value = event.target.dataset.content;
    input.setAttribute('data-tag', event.target.dataset.content);
    input.setAttribute('data-id', selectedBrand);
       const nextInput = mainWrapper.querySelector('[modles-finder]');
    if (nextInput && body.clientWidth > 1025 || body.clientWidth <= 1025) nextInput.focus();
     is_open = true;
    if (nextInput) nextInput.classList.add('is_active');
          
    const modelList = mainWrapper.querySelector('#modles_list');
    const filteredModels = await fetchData('https://phpstack-1204751-4260962.cloudwaysapps.com/api/sected_brand/model', { brand_id: selectedBrand });
    populateList(modelList, filteredModels, 'id', 'name');
   
      elements.header.textContent = 'velg modell';
    elements.breadcrumbs.querySelector('.brand').innerHTML = input.value;
        }
  };

  
  const handleModelClick = async (event) => {
        if(event.target.matches('li')){
    const mainWrapper = event.target.closest('[main-wrapper]');
    const selectedModel = event.target.dataset.value;

    mainWrapper.querySelector('[years-finder]').removeAttribute('disabled');
    const input = mainWrapper.querySelector('[modles-finder]');
    input.value = event.target.dataset.content;
    input.setAttribute('data-tag', `model_${event.target.dataset.content}`);
    input.setAttribute('data-id', selectedModel);
   const nextInput = mainWrapper.querySelector('[years-finder]');
    if (nextInput && body.clientWidth > 1025 || body.clientWidth <= 1025) nextInput.focus();
     is_open = true;
    if (nextInput) nextInput.classList.add('is_active');
    const yearList = mainWrapper.querySelector('#years_list');
    const filteredYears = await fetchData('https://phpstack-1204751-4260962.cloudwaysapps.com/api/sected_model/year', { model_id: selectedModel });
    populateList(yearList, filteredYears, 'id', 'year');
   
    elements.header.textContent = 'velg modell';
    elements.breadcrumbs.querySelector('.model').innerHTML = input.value;
        }
  };

  const handleYearClick = (event) => {
    if(event.target.matches('li')){
    const input = event.target.closest('.wrapper_finder_input').querySelector('input');
    input.value = event.target.dataset.content;
    input.setAttribute('data-tag', `year_${event.target.dataset.content}`);
    elements.breadcrumbs.querySelector('.year').innerHTML = input.value;

    if (body.clientWidth < 1025 || body.clientWidth >= 1025) elements.searchBtn.click();
    }
  };

  const initialize = async () => {
    const response = await fetchData('https://phpstack-1204751-4260962.cloudwaysapps.com/api/all/brand/list');
    elements.brandLists.forEach((brandList, index) => {
      populateList(brandList, response.brands, 'id', 'name', true, response.popular_brands);
      brandList.addEventListener('click', handleBrandClick);
      elements.brandInputs[index].addEventListener('input', () => filterList(elements.brandInputs[index], brandList));
    });
    elements.modelLists.forEach(modelList => modelList.addEventListener('click', handleModelClick));
    elements.yearLists.forEach(yearList => yearList.addEventListener('click', handleYearClick));
  };
  
  initialize();

elements.searchBtn.addEventListener('click', function () {
    const selectedBrand = elements.brandInputs[0]?.dataset.tag;
    const selectedModel = elements.modelInputs[0]?.dataset.tag;
    const selectedYear = elements.yearInputs[0]?.dataset.tag;
    if(!selectedBrand){
       elements.brandInputs[0].focus();
     return;
    }else if(!selectedModel){
       elements.modelInputs[0].focus();
     return;
    }else if(!selectedYear){
       elements.yearInputs[0].focus();
     return;
    }
    else {
      localStorage.setItem("Selected-modle", elements.modelInputs[0]?.value);
      localStorage.setItem("Selected-brand", elements.brandInputs[0]?.value);
      localStorage.setItem("Selected-year", elements.yearInputs[0]?.value);
      let redirectUrl = `https://strommen-bilradio.myshopify.com/collections/all/${(selectedBrand).replace(/[^a-zA-Z0-9_]/g, "-")}+${(selectedModel).replace(/[^a-zA-Z0-9_]/g, "-")}+${selectedYear}`;
       formattedPathSegment = `${(selectedBrand).replace(/[^a-zA-Z0-9_]/g, "-")},${(selectedModel).replace(/[^a-zA-Z0-9_]/g, "-")},${selectedYear}`
      // console.log('formattedPathSegment', formattedPathSegment)
      toggleModelOpener();
       document.querySelector('.main-loading_landing')?.classList.remove('hidden');
      document.querySelector('.main-landing-exhibition-main_search_area')?.classList.remove('hidden');
      document.querySelector('.results_search_grid')?.classList.add('hidden');
       if( document.querySelector('.collection_tags_list')){  document.querySelector('.collection_tags_list').textContent = `${ elements.brandInputs[0]?.value } / ${elements.modelInputs[0]?.value} / ${ elements.yearInputs[0]?.value}`; }
       filterApi = `https://phpstack-1204751-4260962.cloudwaysapps.com/api/custom/filters?collection_id=${collectionId}&special_tags=${formattedPathSegment}`;
     filterValApi = `https://phpstack-1204751-4260962.cloudwaysapps.com/api/Apply/filters/new/base?special_tags=${formattedPathSegment}`;
        filterApiData();
    }
    });
const AllIconCarets = document.querySelectorAll('.caret_icon_finder');
const AllIconCaretClose = document.querySelectorAll('.caret_icon_finder_close');
const backToSearch = document.querySelector('.back-to-search');

  backToSearch.addEventListener('click', function() {
      document.querySelector('.landing-exhibition-main_search_area')?.classList.remove('hidden');
      document.querySelector('.results_search_grid')?.classList.add('hidden');
     document.querySelector('.sticky_bar_after_p_selection')?.classList.add('hidden');
     const listSelectionItems = document.querySelector('.list-selection-items');
  if (listSelectionItems) { 
    listSelectionItems.innerHTML = '';
  }
});
  AllIconCarets?.forEach((btn) => {
  btn.addEventListener('click', function() {
    var Parent = this.closest('.block_finder_input');
    var Input = Parent.querySelector('input');
      Input?.focus();
  });
});
  AllIconCaretClose?.forEach((btn) => {
  btn.addEventListener('click', function() {
    var Parent = this.closest('.block_finder_input');
    var Input = Parent.querySelector('input');
      Input?.blur();
  });
});
  // =============================================Search Model Plate No Api ====================================
 const modleSearchBtn = wrapper ? wrapper.querySelector('.search_vhical_btn') : null;
 const modleSearchinput = wrapper ? wrapper.querySelector('.serach_vhical_input') : null;
     modleSearchBtn?.addEventListener('click', function () {
  const modelNumber = modleSearchinput.value.trim();

  if (!modelNumber) {
        var message = document.createElement('span');
        message.textContent = 'Vennligst skriv inn registreringsnummeret ditt!'
        message.classList.add('error_message_brands');
        body.appendChild(message)
         setTimeout(function(){
        document.querySelector('.error_message_brands')?.remove();
      },2000)
    return;
  }
   document.querySelector('.main-loading_landing')?.classList.remove('hidden');
      document.querySelector('.main-landing-exhibition-main_search_area')?.classList.add('hidden');
      document.querySelector('.results_search_grid')?.classList.add('hidden');
  const apiUrl = `https://phpstack-1204751-4260962.cloudwaysapps.com/api/search/models?model_no=${encodeURIComponent(modelNumber)}`;

  fetch(apiUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      // console.log(data);
      elements.brandInputs[0].value = data.brand_name ? data.brand_name : null;
      elements.modelInputs[0].value = data.model_name ? data.model_name : null;
     elements.yearInputs[0].value = data.year ? data.year : null;
      if(data.brand_name){elements.brandInputs[0].setAttribute('data-tag',data.brand_name)};
     if(data.model_nam){ elements.modelInputs[0].setAttribute('data-tag', `model_${data.model_name}`) };
     if(data.year){elements.yearInputs[0].setAttribute('data-tag', `year_${data.year}`) };
      if (data.brand_name && data.model_name && data.year && data.status == true) {
        
        localStorage.setItem("Selected-modle", data.model_name);
      localStorage.setItem("Selected-brand", data.brand_name);
      localStorage.setItem("Selected-year", data.year);
        
      let redirectUrl = `https://strommen-bilradio.myshopify.com/collections/all/${(data.brand_name).replace(/[^a-zA-Z0-9_]/g, "-")}+model_${(data.model_name).replace(/[^a-zA-Z0-9_]/g, "-")}+year_${data.year}`;
        // console.log('redirectUrl', redirectUrl)
         formattedPathSegment = `${(data.brand_name).replace(/[^a-zA-Z0-9_]/g, "-")},model_${(data.model_name).replace(/[^a-zA-Z0-9_]/g, "-")},year_${data.year}`
        // toggleModelOpener();
       
        if( document.querySelector('.collection_tags_list')){  document.querySelector('.collection_tags_list').textContent = `${ data.brand_name } / ${data.model_name} / ${data.year}`; }
          filterApi = `https://phpstack-1204751-4260962.cloudwaysapps.com/api/custom/filters?collection_id=${collectionId}&special_tags=${formattedPathSegment}`;
     filterValApi = `https://phpstack-1204751-4260962.cloudwaysapps.com/api/Apply/filters/new/base?special_tags=${formattedPathSegment}`;
          filterApiData();
    }else if(data.status == false && data.gpt_response && data.gpt_response.brand && data.gpt_response.model && data.gpt_response.year ){
         
        localStorage.setItem("Selected-modle", data.gpt_response.model);
      localStorage.setItem("Selected-brand", data.gpt_response.brand);
      localStorage.setItem("Selected-year", data.gpt_response.year);
        // toggleModelOpener();
        if( document.querySelector('.collection_tags_list')){  document.querySelector('.collection_tags_list').textContent = `${ data.gpt_response.brand } / ${data.gpt_response.model} / ${data.gpt_response.year}`; }
      let redirectUrl = `https://strommen-bilradio.myshopify.com/collections/all/${(data.gpt_response.brand).replace(/[^a-zA-Z0-9_]/g, "-")}+model_${(data.gpt_response.model).replace(/[^a-zA-Z0-9_]/g, "-")}+year_${data.gpt_response.year}`;
        formattedPathSegment = `${(data.gpt_response.brand).replace(/[^a-zA-Z0-9_]/g, "-")},model_${(data.gpt_response.model).replace(/[^a-zA-Z0-9_]/g, "-")},year_${data.gpt_response.year}`
        // console.log('redirectUrl', redirectUrl)
          filterApi = `https://phpstack-1204751-4260962.cloudwaysapps.com/api/custom/filters?collection_id=${collectionId}&special_tags=${formattedPathSegment}`;
     filterValApi = `https://phpstack-1204751-4260962.cloudwaysapps.com/api/Apply/filters/new/base?special_tags=${formattedPathSegment}`;
          filterApiData();
    }
      else {
        document.querySelector('.main-loading_landing')?.classList.add('hidden');
        // console.log('Message', data.message)
        var message = document.createElement('span');
        message.textContent = 'Vi fant dessverre ikke bilen din med Reg nr. Prøv rullegardinmenyen for å finne bilen din'
        message.classList.add('error_message_brands');
        body.appendChild(message)
         setTimeout(function(){
        document.querySelector('.error_message_brands')?.remove();
      },3000)
      }
    })
    .catch(error => {
      console.error('There was a problem with the fetch operation:', error);
    });
});
// ======================================Filters js ==================================================
  
  var collectionPage = document.body;
  var filtersWrapper = document.querySelector(".page-layout-sidebar-inner-content.old-side-bar-content");
  var newFiltersWrapper = document.querySelector(".custom-page-layout-sidebar-inner-content.page-layout-sidebar-inner-content"); 
  var productCount = document.querySelector("#ProductCount");
  var productGrid  = document.querySelector("#product-grid");
  var defaultProducts = productGrid ? productGrid.innerHTML : null ;
  var collectionId = document.querySelector("#ProductGridContainer") ? document.querySelector("#ProductGridContainer").getAttribute("col-id"): null;
  var collectionLoader = collectionPage ? collectionPage.querySelector(".new-collection-load") : null;
  var filterLoader = collectionPage ? collectionPage.querySelector(".filters_loader") : null;
  var fullWidths = collectionPage ? collectionPage.querySelectorAll(".page-layout-fullwidth") : null;
  var mainContent = collectionPage ? collectionPage.querySelector("#MainContent") : null;
  var mblFilter = collectionPage ? collectionPage.querySelector(".page-layout-sidebar-inner-content.new-filter-data") : null;
  var windowUrl = window.location.href;
  var minVal = 0;
  var sortVal = 0;
  var pageVal = 0;
  var checkVal = 0;
  const url = window.location.href;


function ensureHttps(url) {
    if (url.startsWith("http://")) {
        return url.replace("http://", "https://");
    }
    return url;
}
   function escapeValue(value) {
      if (typeof value === 'string') {
        return value.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      }
      return value;
    }

function handleCheckboxChange() {
    const checkedCheckboxes = collectionPage.querySelectorAll('input.new-filter-input:checked');
    const checkedValues = Array.from(checkedCheckboxes).map(checkbox => ({
        value: checkbox.value,
        name: checkbox.getAttribute('name'),
        filterName: checkbox.getAttribute('active'),
        filterBase: checkbox.getAttribute('filter-base')
    }));

    const sortBy = collectionPage ? collectionPage.querySelector("#collection-sort-order") : null;
    let selectedSort = sortBy ? sortBy.value : '';
    const priceFrom = document.getElementById('min-read-price');
    const priceTo = document.getElementById('max-read-price');
    const minPrice = priceFrom ? priceFrom.value : 0;
    const maxPrice = priceTo ? priceTo.value : '';
  // console.log('maxPrice', maxPrice)
     const urlParams = new URLSearchParams(window.location.search);

   let pageNumber = urlParams.get('page') || 1;

    const requestBody = {};

    const filters = [];
    const filterGroups = {};

    checkedValues.forEach(checkbox => {
        if (!filterGroups[checkbox.filterName]) {
            filterGroups[checkbox.filterName] = {
                filter_name: checkbox.filterName,
                filter_baseon: checkbox.filterBase,
                tags: []
            };
        }
        filterGroups[checkbox.filterName].tags.push(checkbox.value);
    });

    for (const key in filterGroups) {
        filters.push(filterGroups[key]);
    }

    if (filters.length > 0) {
        requestBody.filters = filters;
    }
    if (collectionId) {
        requestBody.collection_id = collectionId;
    }
    if (selectedSort) {
        requestBody.sort_by = selectedSort;
    }
    if (minPrice) {
        requestBody.min_price = minPrice;
    }
    if (maxPrice) {
        requestBody.max_price = maxPrice;
    }
    requestBody.page = pageNumber;

    updateActiveFiltersDisplay(checkedCheckboxes, minPrice, maxPrice);
      requestBody.page = 1
    fetchProducts(requestBody);
  //   updateUrlParams(checkedValues, minPrice, maxPrice, selectedSort, pageNumber);
  // const finalUrl = updateUrlParams('https://example.com/products', checkedValues, minPrice, maxPrice, selectedSort, pageNumber);


}


function updateActiveFiltersDisplay(checkedCheckboxes, minPrice, maxPrice) {
    const activeFiltersContainer = document.getElementById('active-filters');
   if(activeFiltersContainer){ activeFiltersContainer.innerHTML = '';} // Clear existing active filters

    // Display checked checkboxes
    checkedCheckboxes.forEach(checkbox => {
        const checkName = checkbox.getAttribute('name');
        const checkActiveName = checkbox.getAttribute('active');
        const filterValue = checkbox.value;
        const groupName = checkbox.dataset.groupName || 'Filter'; // Assuming checkboxes have a data-group-name attribute

        const filterTag = document.createElement('span');
        filterTag.className = 'active-filter';
        filterTag.innerHTML = `<span class="active_label_name">${checkActiveName}:</span>  ${filterValue} <button class="remove-filter" data-filter="${checkName}" data-value='${filterValue}'><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.41401 6.00001L11.707 1.70701C12.098 1.31601 12.098 0.684006 11.707 0.293006C11.316 -0.0979941 10.684 -0.0979941 10.293 0.293006L6.00001 4.58601L1.70701 0.293006C1.31601 -0.0979941 0.684006 -0.0979941 0.293006 0.293006C-0.0979941 0.684006 -0.0979941 1.31601 0.293006 1.70701L4.58601 6.00001L0.293006 10.293C-0.0979941 10.684 -0.0979941 11.316 0.293006 11.707C0.488006 11.902 0.744006 12 1.00001 12C1.25601 12 1.51201 11.902 1.70701 11.707L6.00001 7.41401L10.293 11.707C10.488 11.902 10.744 12 11 12C11.256 12 11.512 11.902 11.707 11.707C12.098 11.316 12.098 10.684 11.707 10.293L7.41401 6.00001Z" fill="#3D4246"></path></svg></button>`;
        if(activeFiltersContainer){activeFiltersContainer.appendChild(filterTag);}
    });

    // Display price filter if set
  if(minVal === 1){
    if (minPrice || maxPrice) {
        const filterTag = document.createElement('span');
        filterTag.className = 'active-filter';
        filterTag.innerHTML = `<span class="active_label_name price_filters hidden">Price:</span> ${minPrice} - ${maxPrice} <button class="remove-filter" data-filter="price"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.41401 6.00001L11.707 1.70701C12.098 1.31601 12.098 0.684006 11.707 0.293006C11.316 -0.0979941 10.684 -0.0979941 10.293 0.293006L6.00001 4.58601L1.70701 0.293006C1.31601 -0.0979941 0.684006 -0.0979941 0.293006 0.293006C-0.0979941 0.684006 -0.0979941 1.31601 0.293006 1.70701L4.58601 6.00001L0.293006 10.293C-0.0979941 10.684 -0.0979941 11.316 0.293006 11.707C0.488006 11.902 0.744006 12 1.00001 12C1.25601 12 1.51201 11.902 1.70701 11.707L6.00001 7.41401L10.293 11.707C10.488 11.902 10.744 12 11 12C11.256 12 11.512 11.902 11.707 11.707C12.098 11.316 12.098 10.684 11.707 10.293L7.41401 6.00001Z" fill="#3D4246"></path></svg></button>`;
        if(activeFiltersContainer){activeFiltersContainer.appendChild(filterTag);}
    }
  }

    // Show/Hide "Clear All" button

    const clearAllButtonActive = document.querySelector('#active-filters-container #clear-all-filters');
  if(minVal === 1 || checkVal === 1){
    if (checkedCheckboxes.length > 0 || minPrice || maxPrice  ) {
        clearAllButtonActive.classList.remove('hidden');
    } else {
      checkVal = 0;
        clearAllButtonActive.classList.add('hidden');
    }
  }
    // Attach event listeners to remove filter buttons
    document.querySelectorAll('.remove-filter').forEach(button => {
        button.addEventListener('click', function() {
            removeFilter(button.dataset.filter, button.dataset.value);
        });
    });
}
      const clearAllButtons = document.querySelectorAll('#clear-all-filters');
    clearAllButtons.forEach((clearAllButton) => {
clearAllButton.addEventListener('click', function(event) {
  event.preventDefault();
  const checkedCheckboxes = collectionPage.querySelectorAll('input.new-filter-input:checked');
  var currentUrl = window.location.origin + window.location.pathname;
  window.history.pushState({}, '', currentUrl);
  // console.log('All URL parameters removed');
  checkedCheckboxes.forEach((check) => check.checked = false);
  handleCheckboxChange()
});
  })
function removeFilter(filter, value) {
    if (filter === 'price') {
        document.getElementById('min-read-price').value = '';
        document.getElementById('max-read-price').value = '';
    } else {
        const checkbox = document.querySelector(`input.new-filter-input[name="${filter}"][value='${value}']`);
        if (checkbox) {
            checkbox.checked = false;
        }
    }
    handleCheckboxChange();
}

function updateUrlParams(baseUrl, checkedValues, minPrice, maxPrice, selectedSort, pageNumber) {
    const url = new URL(baseUrl);
    url.search = '';
    
    checkedValues.forEach(({ name, value }) => {
        url.searchParams.append(name, value);
    });

    if (minVal === 1) {
        if (minPrice || maxPrice) {
            url.searchParams.append('ttr_price', minPrice + ':' + maxPrice);
        }
    }

    if (sortVal === 1) {
        if (selectedSort) {
            url.searchParams.append('ttr_sort', selectedSort);
        }
    }

    if (pageVal === 1) {
        if (pageNumber) {
            url.searchParams.set('page', pageNumber);
        }
    }

    return url.toString();
}


function fetchProducts(requestBody) {
   if(collectionLoader){ collectionLoader.style.opacity = "0.5";}
    filterLoader?.classList.remove("hidden");

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
    };

    fetch(filterValApi, requestOptions)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
            filterLoader?.classList.add("hidden");
           if(collectionLoader){ collectionLoader.style.opacity = "1";}
            // console.log("Data After Filtering", data);        
            updateProductGrid(Object.values(data.all_products));
            updateProductCount(data.total_count);
            const pagination = {
                current_page: data.pagination.current_page,
                last_page: data.pagination.last_page,
                next_page_url: data.pagination.next_page_url
            };
            createPagination(pagination, requestBody);

        
        })
        .catch(error => {
            console.error('There was a problem with the fetch operation:', error);
        });
}

function updateProductGrid(products) {
    let filterProductContent = '';

    if (products.length === 0) {
        filterProductContent = '<li class="no-products">No products found</li>';
    } else {
        products.slice(0, 24).forEach(singleProduct => {
            let imageUrl = ensureHttps(singleProduct.image_url1);
           function sanitizePrice(price) {
                if (typeof price === 'string') {
                  price = price.replace(/\s/g, '').replace(',', '.');
                }
                return price;
              }

        
        let price = singleProduct.enable_manual_price === 1 && singleProduct.manual_price !== '' 
          ? sanitizePrice(singleProduct.manual_price) 
          : sanitizePrice(singleProduct.price);
        
        let compareAtPrice = singleProduct.enable_manual_price === 1 && singleProduct.manual_compare_price !== '' 
          ? sanitizePrice(singleProduct.manual_compare_price) 
          : sanitizePrice(singleProduct.compare_at_price);
        
        let priceNumber = price !== '' ? parseFloat(price) : 0 ;
        let compareAtPriceNumber = compareAtPrice !== '' ? parseFloat(compareAtPrice) : 0;
        
        let formattedPrice = priceNumber.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        let formattedCompareAtPrice = compareAtPriceNumber.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        
       

                    
            filterProductContent += `
                <li class="grid-item">
                    <label class="card card-product card-product-no-rating color-background-2" for="${singleProduct.source === 'https://www.audiocom.no/' ? singleProduct.sku2 : singleProduct.sku }-single_product-${singleProduct.shopify_variant_id}">
                    <input id="${singleProduct.source === 'https://www.audiocom.no/' ? singleProduct.sku2 : singleProduct.sku }-single_product-${singleProduct.shopify_variant_id}" class="checkbox_select_products" type="checkbox" data-id="${singleProduct.shopify_variant_id}" data-image="${imageUrl}" data-title=" ${singleProduct.title}" data-sku="${singleProduct.source === 'https://www.audiocom.no/' ? singleProduct.sku2 : singleProduct.sku }">
                        <figure class="card-media card-media-contain">
                                <div class="aspect-ratio" style="--ratio-percent: 100%;">
                                    <img class="card-media-image" src="${imageUrl}" width="950" height="950" loading="lazy">
                                </div>

                        </figure>
                        <div class="card-info-wrap">
                            <div class="card-info">
                                <h3 class="card-heading typography-body">
                                  ${singleProduct.title}
                                </h3>
                                <span class="metafields_introducts new-metafields_introducts">${singleProduct.introduction ? singleProduct.introduction : ''}</span>
                                 <span class="product-info-meta-item product-info-meta-item-code">
                          Varenr: <span id="ProductSku-template--17737542074592__product-grid">${singleProduct.source === 'https://www.audiocom.no/' ? singleProduct.sku2 : singleProduct.sku }</span>
                      </span>
                                ${singleProduct.stock_status ? `
                                <div class="badge-stock badge-stock-in" style="margin-left:10px;">
                                    <span class="badge-stock-icon"></span> 
                                    <span class="js-stock-text">Hovedlager: ${singleProduct.stock_status}</span>
                                </div>` : ''}
                                 ${ compareAtPrice > price ? 
                               `<span class="sale_tag_card_per">-${Math.round(((parseInt(compareAtPrice) - parseInt(price)) * 100) / parseInt(compareAtPrice))}% Salg</span>` 
                               : '' 
                            }
                               
                            </div>
                            <div class="card-footer">
                                <div class="price ${compareAtPrice > price ? "price-on-sale" : ""}">
                                    <div class="price-container">
                                        ${compareAtPrice > price ? `
                                        <div class="price-sale">
                                            <span class="visually-hidden">Vanlig pris</span>
                                            <span class="price-discount">
                                                <s class="price-item price-item-regular">${isNaN(compareAtPrice) ? '0.00' : formattedCompareAtPrice} kr</s>
                                            </span>
                                            <span class="visually-hidden">Salgs pris</span>
                                            <span class="price-item price-item-sale price-item-last">
                                                ${isNaN(price) ? '0.00' : formattedPrice } kr
                                                <span class="sup">inkl. mva</span>    
                                            </span>
                                        </div>` : `
                                        <div class="price-regular">
                                            <span class="visually-hidden">Vanlig pris</span>
                                            <span class="price-item price-item-regular">
                                                ${isNaN(price) ? '0.00' : formattedPrice} kr
                                                <span class="sup">inkl. mva</span>
                                            </span>
                                        </div>`}
                                    </div>
                                </div>
                                <div class="card-floating-footer hidden">
                                    <product-form>
                                        <form method="post" action="/cart/add" id="product-form-${singleProduct.shopify_product_id}" accept-charset="UTF-8" class="hidden shopify-product-form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form" data-stock-threshold="3" data-event-context=" - Collection: 1-DIN Spillere">
                                            <input type="hidden" name="form_type" value="product">
                                            <input type="hidden" name="utf8" value="✓">
                                            <input type="hidden" name="id" value="${singleProduct.shopify_variant_id}">
                                            <div class="product-actions card-product-actions">
                                                <div class="product-actions-add-to-cart">
                                                    <button type="submit" name="add" class="button button-secondary button-add-to-cart button-solid">
                                                        <span>Legg i handlekurv</span>
                                                        <div class="button-overlay-spinner hidden">
                                                            <span class="spinner-xs"></span>
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="product-form-error-message-wrapper form-status form-status-error" role="alert" hidden="">
                                                <span class="product-form-error-message"></span>
                                            </div>
                                            <input type="hidden" name="product-id" value="8317999907040">
                                            <input type="hidden" name="section-id" value="template--17924865786080__product-grid">
                                        </form>
                                    </product-form>
                                </div>
                                <div class="card-list-floating-footer hidden">
                                    <product-form class="product-form" data-hide-errors="">
                                        <div class="product-form-error-message-wrapper form-status form-status-error" role="alert"
                                            hidden="">
                                            <span class="product-form-error-message"></span>
                                        </div>
                    
                                        <form method="post" action="/cart/add" id="product-form-${singleProduct.shopify_product_id}" accept-charset="UTF-8"
                                            class="shopify-product-form" enctype="multipart/form-data" novalidate="novalidate"
                                            data-type="add-to-cart-form" data-stock-threshold="3"
                                            data-event-context=" - Collection: BILSTEREO"><input type="hidden" name="form_type"
                                                value="product"><input type="hidden" name="utf8" value="✓">
                                            <input type="hidden" name="id" value="${singleProduct.shopify_variant_id}">
                                            <div class="product-actions">
                                                <div class="product-actions-add-to-cart
                                            product-actions-add-to-cart-solid
                                                product-actions-add-to-cart-quantity
                                            
                                            
                                            ">
                                                    <quantity-input class="quantity-input">
                                                        <button type="button" name="minus"
                                                            class="quantity-input-button quantity-input-minus no-js-hidden">
                                                            −
                                                            <span class="visually-hidden">Reduser mengden for Pioneer MVH330DAB, kort
                                                                chassis</span>
                                                        </button>
                                                        <label for="quantity-input-template--${singleProduct.shopify_product_id}__product-grid"
                                                            class="visually-hidden">Antall</label>
                                                        <input name="quantity" type="number" class="quantity-input-field"
                                                            id="quantity-input-template--${singleProduct.shopify_product_id}__product-grid" min="1" value="1">
                                                        <button type="button" name="plus"
                                                            class="quantity-input-button quantity-input-plus no-js-hidden">
                                                            +
                                                            <span class="visually-hidden">Øk mengden for Pioneer MVH330DAB, kort
                                                                chassis</span>
                                                        </button>
                                                    </quantity-input>
                    
                                                    <button type="submit" name="add"
                                                        class="button button-secondary button-add-to-cart"><span>Legg til i
                                                            handlekurv</span>
                                                        <div class="button-overlay-spinner hidden">
                                                            <span class="spinner-xs"></span>
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>
                                            <input type="hidden" name="product-id" value="${singleProduct.shopify_variant_id}"><input type="hidden"
                                                name="section-id" value="template--${singleProduct.shopify_product_id}__product-grid">
                                        </form>
                                    </product-form>
                                </div>
                            </div>
                        </div>
                    </label>
                </li>`;
        });
    }

    if(productGrid){
      productGrid.innerHTML = filterProductContent;
      // console.log('content_is_updated');
      document.querySelector('.main-loading_landing')?.classList.add('hidden');
      document.querySelector('.landing-exhibition-main_search_area')?.classList.add('hidden');
      document.querySelector('.results_search_grid')?.classList.remove('hidden');
      var checkBoxes = document.querySelectorAll('.checkbox_select_products');
    checkBoxes?.forEach((checkbox) => {
      checkbox.addEventListener('change', function(){
        checkSelectedProducts()
          // console.log('function is working')
      })
    })
    }
}

function updateProductCount(totalCount) {
    if(productCount){productCount.innerHTML = totalCount + " Produkter";}
}

function fetchProductsFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const checkedValues = [];

    // Loop through all URL parameters and update the checkboxes based on name and value
    urlParams.forEach((value, key) => {
        if (!['ttr_price', 'ttr_sort', 'page'].includes(key)) {
            const escapedValue = CSS.escape(value);
            const checkbox = document.querySelector(`input.new-filter-input[name="${key}"][value="${escapedValue}"]`);
            if (checkbox) {
                checkbox.checked = true;
                checkedValues.push({
                    name: key,
                    value: value,
                    filterName: checkbox.getAttribute('active'),
                    filterBase: checkbox.getAttribute('filter-base')
                });
                checkVal = 1;
            }
        }
    });
    const ttr_price = urlParams.get('ttr_price') ? urlParams.get('ttr_price').split(':') : [null, null];
    const ttr_sort = urlParams.get('ttr_sort');
    const page = urlParams.get('page') || 1;
    if (ttr_price[0]) {
        minVal = 1;
        document.getElementById('min-read-price').value = ttr_price[0];
    }
    if (ttr_price[1]) {
        minVal = 1;
        document.getElementById('max-read-price').value = ttr_price[1];
    }
    if (ttr_sort) {
        sortVal = 1;
        document.querySelector("#collection-sort-order").value = ttr_sort;
    }
    if (page) {
        pageVal = 1;
        document.querySelectorAll('.custom-pagination').forEach(pageLink => {
            const pageN = pageLink.querySelector(".new-pagnate");
            const pageNumber = pageN ? pageN.value : null;
            if (pageNumber && parseInt(pageNumber) === parseInt(page)) {
                pageLink.classList.add('page-number-active');
            }
        });
    }

    handleCheckboxChange();
}


    function escapeValue(value) {
      if (typeof value === 'string') {
        return value.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      }
      return value;
    }

function filterApiData() {
  replaceInnerHTMLWithProducts("#product-grid");
  replaceInnerHTMLWithFilters(".new-filter-data");
    fetch(filterApi)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
            // console.log("Filters Data", data);
            var filters = data.filters;
             updateProductCount(data.total_product_count);
            var filterContent = ""; 
            var priceFilterContent = `
                <div class="js-filter  price_filter">
                    <div>
                        <collapsible-expandable expanded="true">
                            <div class="facet">
                                <button class="facet-toggle" type="button" aria-expanded="true">
                                    <span>Pris</span>
                                    <span class="angle angle-down">
                                        <span class="angle-icon"></span>
                                    </span>
                                </button>
                                <div class="facet-content">
                                    <div class="facet-content-header js-price-range-header">
                                        <span>Høyeste pris er ${data.max_price} kr</span>
                                    </div>
                                    <price-range>
                                        <div class="facets-price-range">
                                            <div class="facet-price-range-field">
                                                <span class="facet-price-range-currency">kr</span>
                                                <label for="Pris-from" class="visually-hidden">Fra</label>
                                                <input type="number" id="min-read-price" name="filter.v.price.gte" placeholder="Fra" min="0" value="0" max="${data.max_price}" >
                                            </div>
                                            <div class="facet-price-range-field">
                                                <span class="facet-price-range-currency">kr</span>
                                                <label for="Pris-to" class="visually-hidden">Til</label>
                                                <input type="number"  id="max-read-price" name="filter.v.price.lte"  max="${data.max_price}" placeholder="Til" value="" min="0"  >
                                            </div>
                                        </div>
                                    </price-range>
                                </div>
                                <div class="range-slider">
                                  <span class="hidden">
                                    <input class="min-number-range" type="number" value="0" min="0" max="44">
                                    <input class="max-number-range" type="number" value="54.00" min="21" max="54.00">
                                  </span>
                                                         
                                  <input id="Pris-from" name="filter.v.price.gte" value="0" min="0" max="${data.max_price}" step="100" type="range">
                                  <span id="range-min-tooltip" style="left: 81.4815%;">$<span>21</span></span>              
                                  <input id="Pris-to" name="filter.v.price.lte" value="${data.max_price}" min="0" max="${data.max_price}" step="100" type="range">
                                  <span id="range-max-tooltip" style="left: 38.8889%;">$<span>21</span></span> 
                                   
                                </div>
                                
                                 <div class="price-ranges ">
                                 <span>0</span>
                                 <span>${data.max_price}</span>
                                 </div>
                                
                            </div>
                        </collapsible-expandable>
                        
                    </div>
                </div>`;

            filters.forEach(function(filter) {
                var exlcudedCollections = JSON.parse(filter.excluded_collections);
                // console.log("Filter Status", filter.status);
                if (exlcudedCollections.includes(collectionId) && collectionId) {
                    // console.log("No HTML");
                    filterLoader?.classList.add("hidden");
                    mainContent.style.opacity = "1";
                  if(filtersWrapper){  filtersWrapper.style.display = "block";}
                }else {
                

                    document.querySelector("body").classList.add("new-app-filters");
                    filterLoader?.classList.add("hidden");
                    mainContent.style.opacity = "1";
                    
                    var filterTags = filter.tags;
                    var filterLabel = filter.group_name;

                    // Add HTML content for the current active filter
                    filterContent += `
                    <div class="js-filter">
                        <div>
                            <collapsible-expandable expanded="true">
                                <div class="facet">
                                    <button class="facet-toggle" type="button" aria-expanded="true">
                                        <span>${filterLabel}</span>
                                        <span class="angle angle-down">
                                            <span class="angle-icon"></span>
                                        </span>
                                    </button>
                                    <div class="facet-content">
                                        <ul class="facet-options-list custom-filters-list" aria-expanded="false">`;
                   let Tags_Count  = 0;
                    filterTags.forEach(function(singleTag) {
                        if(singleTag.product_count > 0 ){Tags_Count ++ }
                        filterContent += `
                        ${singleTag.product_count > 0 ? `<li class="facet-options-list-item">
                            <span class="checkbox-facet">
                                <label class="checkbox-facet-label">
                                    <input name="ttr_${filter.group_name}"  value="${escapeValue(singleTag.tag)}" active="${filter.group_name}" filter-base="${filter.base_on}" class="new-filter-input" type="checkbox" />
                                    <span class="checkbox-facet-check"></span>
                                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M17.5303 9.53033C17.8232 9.23744 17.8232 8.76256 17.5303 8.46967C17.2374 8.17678 16.7626 8.17678 16.4697 8.46967L17.5303 9.53033ZM9.99998 16L9.46965 16.5304C9.76255 16.8232 10.2374 16.8232 10.5303 16.5303L9.99998 16ZM7.53027 12.4697C7.23737 12.1768 6.7625 12.1768 6.46961 12.4697C6.17671 12.7626 6.17672 13.2374 6.46961 13.5303L7.53027 12.4697ZM16.4697 8.46967L9.46965 15.4697L10.5303 16.5303L17.5303 9.53033L16.4697 8.46967ZM6.46961 13.5303L9.46965 16.5304L10.5303 15.4697L7.53027 12.4697L6.46961 13.5303Z"></path>
                                    </svg>
                                    <span class="checkbox-facet-label-text">  ${singleTag.tag_label ? singleTag.tag_label : singleTag.tag}</span>
                                    <span class="checkbox-facet-label-count">${singleTag.product_count}</span>
                                </label>
                            </span>
                        </li>` : ''} `;
                    });

                    filterContent += `
                                        </ul>
                                         ${Tags_Count > 9 ?  `<div class="facet-content-footer">
                                     <button class="button-text-link facet-button-more" type="button" form="FacetsFilterForm">+ Vis mindre</button>
                                    </div>`: ''}
                                    </div>
                                </div>
                            </collapsible-expandable>
                        </div>
                    </div>`;
                }
            });
           if(newFiltersWrapper){ newFiltersWrapper.innerHTML = filterContent + priceFilterContent;}
           if(mblFilter){ mblFilter.innerHTML = filterContent +  priceFilterContent;}

             if (window.location.search) {
            fetchProductsFromUrl();
             } else if (formattedPathSegment) {
            fetchProductsFromUrl();
             }
              else{
               if(productGrid){productGrid.innerHTML = defaultProducts;}
             }
          
            const priceFrom = document.getElementById('Pris-from');
            const priceTo = document.getElementById('Pris-to');
            const minRead = document.getElementById('min-read-price');
            const maxRead = document.getElementById('max-read-price');
           
            if (priceFrom && priceTo) {
                minRead.addEventListener('input', function() {
                  minVal = 1;
                    handleCheckboxChange();
                });

                maxRead.addEventListener('input', function() {
                   minVal = 1;
                    handleCheckboxChange();
                });
            }
          
            
            
            const checkboxes = collectionPage ? collectionPage.querySelectorAll('input.new-filter-input') : null;
            if (checkboxes.length > 0) {
                checkboxes.forEach(function(checkbox) {
                    checkbox.addEventListener('change', function(){
                      checkVal = 1;
                       handleCheckboxChange();
                    });     
                });
            }
          handleCheckboxChange()
        })
        .catch(error => {
            console.error('There was a problem with the fetch operation:', error);
        });
}

 function checkSelectedProducts(){
  var selectedCheckBoxes = document.querySelectorAll('.checkbox_select_products:checked');
  let ProductsHtml = '';
   if( selectedCheckBoxes.length > 0){
   document.querySelector('.sticky_bar_after_p_selection')?.classList.remove('hidden')
   }else{
   document.querySelector('.sticky_bar_after_p_selection')?.classList.add('hidden') 
   }
   let index = 0;
  selectedCheckBoxes.forEach((checkbox) => {
    let imageUrl = checkbox.getAttribute('data-image');
    let itemTitle = checkbox.getAttribute('data-title');
    let SKU = checkbox.getAttribute('data-sku');
    let VariantId = checkbox.getAttribute('data-id');
     index ++ 
    ProductsHtml += `<div class="selection_products_list_item">
      <span class="cancle_item" data-sku="${SKU}">✕</span>
      <div class="item_image_selection"><img src="${imageUrl}"></div>
      <div class="info_wrapper_item_selection">
      <input type="hidden" name="contact[Product${index} SKU]" value="${SKU}">
      <input type="hidden" name="contact[Product${index} Name]" value="${itemTitle}">
        <h4>${itemTitle}</h4>
        <span class="product-info-meta-item product-info-meta-item-code">
          Varenr: <span id="ProductSku-template--17737542074592__product-grid">${SKU}</span>
        </span>
        <quantity-input class="quantity-input">
          <button type="button" name="minus" class="quantity-input-button quantity-input-minus no-js-hidden">−
            <span class="visually-hidden">Reduser mengden for ${itemTitle}</span>
          </button>
          <label for="quantity-input-template--${VariantId}__product-grid" class="visually-hidden">Antall</label>
          <input name="contact[Product${index} Quantity]" type="number" class="quantity-input-field"
            id="quantity-input-template--${VariantId}__product-grid" min="1" value="1">
          <button type="button" name="plus" class="quantity-input-button quantity-input-plus no-js-hidden">+
            <span class="visually-hidden">Øk mengden for ${itemTitle}</span>
          </button>
        </quantity-input>
      </div>
    </div>`;
  });
  const listSelectionItems = document.querySelector('.list-selection-items');
  if (listSelectionItems) { 
    listSelectionItems.innerHTML = ProductsHtml;
    document.querySelectorAll('.cancle_item')?.forEach((cancle) => {
      cancle.addEventListener('click', function(){
        var TargetSku = this.getAttribute('data-sku');
       document.querySelector(`.checkbox_select_products[data-sku="${TargetSku}"]`).checked = false;
        // this.closest('.selection_products_list_item').remove();
        checkSelectedProducts();
      })
    })
  }
  
  // console.log('function is working');
}

function createPagination(pagination, requestBody) {
    const { current_page, last_page, next_page_url } = pagination;
    const paginationContainer = document.querySelector('.pagination');

    // Clear existing pagination
   if(paginationContainer) {paginationContainer.innerHTML = '';}

    if (last_page > 1 && paginationContainer) {
        // Show first page
        paginationContainer.innerHTML += `
            <span class="page-number custom-pagination ${current_page === 1 ? 'page-number-active' : ''}" data-page-number="1">1
                <input class="new-pagnate" type="hidden" value="1" />
            </span>`;

        // Show ellipsis if needed
        if (current_page > 3) {
            paginationContainer.innerHTML += `<span class="page-number">…</span>`;
        }

        // Calculate the range of page numbers to show
        let start = Math.max(2, current_page - 1);
        let end = Math.min(last_page - 1, current_page + 1);

        // Adjust the range if it's too close to the start or end
        if (current_page <= 3) {
            start = 2;
            end = Math.min(4, last_page - 1);
        } else if (current_page >= last_page - 2) {
            start = Math.max(2, last_page - 3);
            end = last_page - 1;
        }

        // Show the range of page numbers
        for (let i = start; i <= end; i++) {
            paginationContainer.innerHTML += `
                <span class="page-number custom-pagination ${current_page === i ? 'page-number-active' : ''}" data-page-number="${i}">${i}
                    <input class="new-pagnate" type="hidden" value="${i}" />
                </span>`;
        }

        // Show ellipsis if needed
        if (current_page < last_page - 2) {
            paginationContainer.innerHTML += `<span class="page-number">…</span>`;
        }

        // Show last page
        paginationContainer.innerHTML += `
            <span class="page-number custom-pagination ${current_page === last_page ? 'page-number-active' : ''}" data-page-number="${last_page}">${last_page}
                <input class="new-pagnate" type="hidden" value="${last_page}" />
            </span>`;

        // Add the next button if there are more pages
        if (next_page_url !== null) {
            paginationContainer.innerHTML += `
                <span class="custom-pagination page-number page-number-next" data-page-number="${current_page + 1}" aria-label="Neste side">
                    <svg class="next-page" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.46967 19.4697C8.17678 19.7626 8.17678 20.2374 8.46967 20.5303C8.76256 20.8232 9.23744 20.8232 9.53033 20.5303L8.46967 19.4697ZM17 12L17.5303 12.5303C17.671 12.3897 17.75 12.1989 17.75 12C17.75 11.8011 17.671 11.6103 17.5303 11.4697L17 12ZM9.53033 3.46967C9.23744 3.17678 8.76256 3.17678 8.46967 3.46967C8.17678 3.76256 8.17678 4.23744 8.46967 4.53033L9.53033 3.46967ZM9.53033 20.5303L17.5303 12.5303L16.4697 11.4697L8.46967 19.4697L9.53033 20.5303ZM17.5303 11.4697L9.53033 3.46967L8.46967 4.53033L16.4697 12.5303L17.5303 11.4697Z" fill="#001A72"></path>
                    </svg>
                    <input class="new-pagnate" type="hidden" value="${current_page + 1}" />
                </span>`;
        }

        // Add event listeners to pagination elements
        paginationContainer.querySelectorAll('.custom-pagination').forEach(pageLink => {
            pageLink.addEventListener('click', function() {
                const newPageInput = pageLink.querySelector(".new-pagnate");
                const pageNumber = newPageInput ? newPageInput.value : pageLink.dataset.pageNumber;

                requestBody.page = pageNumber;
                fetchProducts(requestBody);

                // Update URL with the new page number
                const url = new URL(window.location);
                url.searchParams.set('page', pageNumber);
                history.pushState(null, null, url.toString());
            });
        });
    }
}


  function addSkeletonToMainContent() {
    const allElements = productGrid ? productGrid.querySelectorAll("*") : null;
    allElements.forEach(element => element.classList.add("skeleton"));
}

function removeSkeletonFromMainContent() {
    const allElements = productGrid ? productGrid.querySelectorAll("*") : null;
    allElements.forEach(element => element.classList.remove("skeleton"));
}


function generateProductHTML() {
    return `
        <li class="grid-item">
            <div class="card card-product card-product-no-rating color-background-2">
                <figure class="card-media card-media-contain" data-handle="4-connect-1-5mm2-hoyttalerkabel-100-ren-kobber">
                    <a href="" data-bss-pl="active">
                        <div class="aspect-ratio skeleton" style="--ratio-percent: 100%;">   
                        </div>
                    </a>
                </figure>
                <div class="card-info-wrap">
                    <div class="card-info">
                        <h3 class="card-heading skeleton typography-body" data-handle="4-connect-1-5mm2-hoyttalerkabel-100-ren-kobber">
                            <a href="" data-bss-pl="active">4 CONNECT 1,5mm2 høyttalerkabel, 100% ren kobber</a>
                        </h3>
                        <span class="metafields_introducts new-metafields_introducts skeleton">German Car Audio</span>
                        
                        <div class="badge-stock badge-stock-in skeleton" style="margin-left:10px;">
                            <span class="js-stock-text skeleton">Hovedlager: 7</span>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="price ">
                            <div class="price-container">
                                <div class="price-regular">
                                    <span class="visually-hidden">Vanlig pris</span>
                                    <span class="price-item price-item-regular skeleton" >
                                        650.00 kr
                                        <span class="sup skeleton">inkl. mva</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="card-floating-footer">
                            <product-form>
                                <form method="post" action="/cart/add" id="product-form-8317462708448" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form" data-stock-threshold="3" data-event-context=" - Collection: 1-DIN Spillere">
                                    <input type="hidden" name="form_type" value="product">
                                    <input type="hidden" name="utf8" value="✓">
                                    <input type="hidden" name="id" value="45544669020384">
                                    <div class="product-actions card-product-actions">
                                        <div class="product-actions-add-to-cart">
                                            <button type="submit" name=" add" class="skeleton button button-secondary button-add-to-cart button-solid">
                                                <span>Legg i handlekurv</span>
                                                <div class="button-overlay-spinner hidden">
                                                    <span class="spinner-xs"></span>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="product-form-error-message-wrapper form-status form-status-error" role="alert" hidden="">
                                        <span class="product-form-error-message"></span>
                                    </div>
                                    <input type="hidden" name="product-id" value="8317999907040">
                                    <input type="hidden" name="section-id" value="template--17924865786080__product-grid">
                                </form>
                            </product-form>
                        </div>
                    </div>
                </div>
            </div>
        </li>`;
}
  function generateFilterHTML() {
    return `
    <div class="js-filter">
        <div>
            <collapsible-expandable expanded="true">
                <div class="facet">
                    <button class="facet-toggle skeleton" type="button" aria-expanded="true">
                        <span>Category 1</span>
                        <span class="angle angle-down">
                            <span class="angle-icon"></span>
                        </span>
                    </button>
                    <div class="facet-content">
                        <ul class="facet-options-list" aria-expanded="false">
                            <li class="facet-options-list-item">
                                <span class="checkbox-facet skeleton">
                                    <label class="checkbox-facet-label skeleton">
                                        <input name="ttr_Category 1" value="10" active="Category 1" class="new-filter-input hidden" type="checkbox">
                                        <span class="checkbox-facet-check skeleton"></span>
                                        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17.5303 9.53033C17.8232 9.23744 17.8232 8.76256 17.5303 8.46967C17.2374 8.17678 16.7626 8.17678 16.4697 8.46967L17.5303 9.53033ZM9.99998 16L9.46965 16.5304C9.76255 16.8232 10.2374 16.8232 10.5303 16.5303L9.99998 16ZM7.53027 12.4697C7.23737 12.1768 6.7625 12.1768 6.46961 12.4697C6.17671 12.7626 6.17672 13.2374 6.46961 13.5303L7.53027 12.4697ZM16.4697 8.46967L9.46965 15.4697L10.5303 16.5303L17.5303 9.53033L16.4697 8.46967ZM6.46961 13.5303L9.46965 16.5304L10.5303 15.4697L7.53027 12.4697L6.46961 13.5303Z"></path>
                                        </svg>
                                        <span class="checkbox-facet-label-text">10"</span>
                                        <span class="checkbox-facet-label-count skeleton">58</span>
                                    </label>
                                </span>
                            </li> 
                            <li class="facet-options-list-item">
                                <span class="checkbox-facet skeleton">
                                    <label class="checkbox-facet-label skeleton" >
                                        <input name="ttr_Category 1" value="Audi" active="Category 1" class="new-filter-input hidden" type="checkbox">
                                        <span class="checkbox-facet-check skeleton"></span>
                                        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17.5303 9.53033C17.8232 9.23744 17.8232 8.76256 17.5303 8.46967C17.2374 8.17678 16.7626 8.17678 16.4697 8.46967L17.5303 9.53033ZM9.99998 16L9.46965 16.5304C9.76255 16.8232 10.2374 16.8232 10.5303 16.5303L9.99998 16ZM7.53027 12.4697C7.23737 12.1768 6.7625 12.1768 6.46961 12.4697C6.17671 12.7626 6.17672 13.2374 6.46961 13.5303L7.53027 12.4697ZM16.4697 8.46967L9.46965 15.4697L10.5303 16.5303L17.5303 9.53033L16.4697 8.46967ZM6.46961 13.5303L9.46965 16.5304L10.5303 15.4697L7.53027 12.4697L6.46961 13.5303Z"></path>
                                        </svg>
                                        <span class="checkbox-facet-label-text">Audi</span>
                                        <span class="checkbox-facet-label-count skeleton">1</span>
                                    </label>
                                </span>
                            </li> 
                            <li class="facet-options-list-item">
                                <span class="checkbox-facet skeleton">
                                    <label class="checkbox-facet-label skeleton">
                                        <input name="ttr_Category 1" value="Audi" active="Category 1" class="new-filter-input hidden" type="checkbox">
                                        <span class="checkbox-facet-check skeleton"></span>
                                        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17.5303 9.53033C17.8232 9.23744 17.8232 8.76256 17.5303 8.46967C17.2374 8.17678 16.7626 8.17678 16.4697 8.46967L17.5303 9.53033ZM9.99998 16L9.46965 16.5304C9.76255 16.8232 10.2374 16.8232 10.5303 16.5303L9.99998 16ZM7.53027 12.4697C7.23737 12.1768 6.7625 12.1768 6.46961 12.4697C6.17671 12.7626 6.17672 13.2374 6.46961 13.5303L7.53027 12.4697ZM16.4697 8.46967L9.46965 15.4697L10.5303 16.5303L17.5303 9.53033L16.4697 8.46967ZM6.46961 13.5303L9.46965 16.5304L10.5303 15.4697L7.53027 12.4697L6.46961 13.5303Z"></path>
                                        </svg>
                                        <span class="checkbox-facet-label-text">Audi</span>
                                        <span class="checkbox-facet-label-count skeleton">1</span>
                                    </label>
                                </span>
                            </li> 
                        </ul>
                        <div class="facet-content-footer">
                            <button class="button-text-link skeleton facet-button-more" type="button" form="FacetsFilterForm">+ Vis mer</button>
                        </div>
                    </div>
                </div>
            </collapsible-expandable>
        </div>
    </div>`;
}
  function replaceInnerHTMLWithFilters(containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    let filtersHTML = '';
    for (let i = 0; i < 2; i++) {
        filtersHTML += generateFilterHTML();
    }

    container.innerHTML = filtersHTML;
}
  function replaceInnerHTMLWithProducts(containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    let productsHTML = '';
    for (let i = 0; i < 24; i++) {
        productsHTML += generateProductHTML();
    }

    container.innerHTML = productsHTML;
}
  if(collectionPage){
    // filterApi = `https://phpstack-1204751-4260962.cloudwaysapps.com/api/custom/filters?collection_id=${collectionId}&special_tags=Volkswagen,model_Crafter,year_2013`;
    //  filterValApi = `https://phpstack-1204751-4260962.cloudwaysapps.com/api/Apply/filters/new/base?special_tags=Volkswagen,model_Crafter,year_2013`;
   // if( document.querySelector('.collection_tags_list')){  document.querySelector('.collection_tags_list').textContent = 'Volkswagen / Crafter / 2013' }
   //        filterApiData();
    const sortBy = collectionPage ? collectionPage.querySelector("#collection-sort-order") :  null;
         sortBy?.addEventListener("change",function(){
              sortVal = 1;
           handleCheckboxChange();
         });
  }

// ============================POPUPS FUNCTIONS======================
  document.querySelectorAll('.form_overlay')?.forEach((overlay) => {
    overlay.addEventListener('click', function(){
      this.closest('[popup-wrapper]')?.classList.add('hidden');
      var location = window.location.href;
        document.querySelector('#submition-form .heading-contact-popup')?.remove();
       document.querySelector('#submition-form .text-contact-popup')?.remove();
    })
  })
  document.querySelector('.cancle_selection_popup')?.addEventListener('click', function(){
      this.closest('.sticky_bar_after_p_selection')?.classList.add('hidden');
     var checkBoxes = document.querySelectorAll('.checkbox_select_products:checked');
    checkBoxes.forEach((checkbox) => {
        checkbox.checked = false;
    });
    })
  document.querySelectorAll('[open-popup]')?.forEach((opener) => {
    opener.addEventListener('click', function(){
      var selectorOpen = this.getAttribute('open-popup');
      var selectorHide = this.getAttribute('close-popup');
      document.querySelector(`${selectorOpen}`)?.classList.remove('hidden');
     if(selectorHide){ document.querySelector(`${selectorHide}`)?.classList.add('hidden');}
    })
  })

// =======================Dynamic Checkout Function =======================
  document.querySelectorAll('.perform_dynaic_checkout')?.forEach((checkout) => {
    checkout.addEventListener('click', function(){
     checkoutWithSelectedProducts();
    })
  })

async function checkoutWithSelectedProducts() {
  setCookie("source", 'exhibition', 1);
  var selectedCheckBoxes = document.querySelectorAll('.checkbox_select_products:checked');
  let productsToAdd = [];
  selectedCheckBoxes.forEach((checkbox) => {
    let variantId = checkbox.getAttribute('data-id');
    let quantity = document.getElementById(`quantity-input-template--${variantId}__product-grid`).value; // Get quantity
    productsToAdd.push({ id: variantId, quantity: parseInt(quantity) });
  });

  if (productsToAdd.length === 0) {
       // console.log('Message', 'No Product Selected')
        var message = document.createElement('span');
        message.textContent = 'Please Select A product'
        message.classList.add('error_message_brands');
        body.appendChild(message)
         setTimeout(function(){
        document.querySelector('.error_message_brands')?.remove();
      },2000)
    return;
  }

  try {
    await fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    // console.log('Cart cleared');

    for (let product of productsToAdd) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: product.id,
          quantity: product.quantity,
        }),
      });
      // console.log(`Added product ${product.id} with quantity ${product.quantity}`);
    }
    window.location.href = '/checkout'; 

  } catch (error) {
    console.error('Error during checkout:', error);
  }
}
 var location = window.location.href;
if (location.includes('?contact_posted') && location.includes('#exhibition_ContactForm')) {
document.querySelector('#submition-form').classList.remove('hidden');
  setTimeout(function(){
const params = new URLSearchParams(window.location.search);
params.delete("contact_posted");
const newUrl = window.location.pathname;
window.history.replaceState({}, '', newUrl);
console.log(newUrl);

  },500);
}
});
